export default "__VITE_ASSET__8b22748b__"